(() => {
  'use strict';
  class GiftApiError extends Error {
    constructor(code) { super(code); this.code = code; }
  }
  class GiftApi {
    constructor(base, fetchImpl = window.fetch.bind(window)) {
      const url = new URL(base, window.location.origin);
      if (url.origin !== window.location.origin || !/^\/[a-z0-9_/-]+$/i.test(url.pathname) || url.search || url.hash) throw new Error('Invalid gifting endpoint');
      this.base = url.pathname.replace(/\/$/, ''); this.fetch = fetchImpl;
    }
    async request(route, method = 'GET', body) {
      // Refresh before starting a mutation; never replay a submitted write.
      if (method !== 'GET' && Number(String(this.csrfToken || '').split('.')[0]) <= Date.now() + 30_000) await this.session();
      const headers = { Accept: 'application/json' };
      if (this.sessionToken) headers['X-DAC-Gifting-Session'] = this.sessionToken;
      if (method !== 'GET') { headers['Content-Type'] = 'application/json'; headers['X-DAC-Gifting-CSRF'] = this.csrfToken || ''; }
      let response, result;
      try {
        response = await this.fetch(`${this.base}/${route}`, { method, headers, credentials: 'same-origin', cache: 'no-store', redirect: 'error', ...(['checkout', 'checkout-status'].includes(route) ? { signal: AbortSignal.timeout(route === 'checkout' ? 45000 : 15000) } : {}), ...(body ? { body: JSON.stringify(body) } : {}) });
        result = await response.json();
      } catch { throw new GiftApiError(method === 'GET' ? 'GIFTING_UNAVAILABLE' : 'REQUEST_UNCERTAIN'); }
      if (!response.ok) throw new GiftApiError(result.code || 'GIFTING_UNAVAILABLE');
      return result;
    }
    async session() {
      const result = await this.request('session');
      this.csrfToken = result.csrfToken;
      if (result.sessionToken) this.sessionToken = result.sessionToken;
      return result;
    }
    cartPlan(cart, version, plan) { return this.request('plan', 'POST', { action: plan ? 'save' : 'read', cartToken: cart.token, ...(plan ? { version, plan } : {}) }); }
    async saveRecipient(recipient, id, version) { return (await this.request('recipients', id ? 'PUT' : 'POST', { recipient, id, version })).recipient; }
    removeRecipient(id, version) { return this.request('recipients', 'DELETE', { id, version }); }
    async quote(cart, details) {
      if (cart.items.some(item => item.selling_plan_allocation || item.gift_card)) throw new GiftApiError('UNSUPPORTED_GIFT_CART');
      // Prices, customer identity and provider tokens never come from this UI.
      const lines = cart.items.map(item => ({ key: item.key, variantId: String(item.variant_id), quantity: item.quantity, properties: item.properties || {}, expectedTotal: `${Math.floor(item.final_line_price / 100)}.${String(item.final_line_price % 100).padStart(2, '0')}` }));
      const { cartReference } = await this.request('cart', 'POST', { lines, currency: cart.currency });
      return this.request('quote', 'POST', { ...details, cartReference });
    }
    checkout(quoteId) { return this.request('checkout', 'POST', { quoteId }); }
    checkoutStatus(quoteId) { return this.request('checkout-status', 'POST', { quoteId }); }
    clear() { this.csrfToken = ''; this.sessionToken = ''; }
  }
  window.DacGiftApi = GiftApi;
})();
